/**
 * Added to Cart tracking. Diffs paid cart lines on cart:updated / cart:build
 * (the queue bypasses both Klaviyo fetch interception and Shopify's Ajax-cart
 * instrumentation). Fires Klaviyo `_learnq` AND Shopify's standard
 * `product_added_to_cart` web-pixel event so Shopify Analytics and any
 * subscribed ad pixels record the add.
 */
(function () {
  if (window.__SC_KLAVIYO_ATC_INIT__) return;
  window.__SC_KLAVIYO_ATC_INIT__ = true;

  var STORE_ORIGIN = 'https://www.seedcube.com.au';
  var DEBOUNCE_MS = 300;
  var debounceTimer = null;
  var pendingCartHint = null;
  var paidSnapshot = Object.create(null);

  /* Trekkie visibility telemetry (22/07/2026): counts Shopify's own
   * "Added Product" analytics events so every custom Added-to-Cart event can
   * report whether Shopify's listener saw the add. Segment TrekkieSawAdd=false
   * in Klaviyo to locate the sessions/pages where Shopify admin ATC tracking
   * still misses real adds. Trekkie's boot stub defines lib.track early and the
   * real trekkie REPLACES lib at load, so we re-wrap on an interval (marker on
   * the function, not the lib) for the first 90s of the page. */
  var trekkieSpyTimer = setInterval(function () {
    try {
      var sa = window.ShopifyAnalytics;
      if (!sa || !sa.lib || typeof sa.lib.track !== 'function') return;
      if (sa.lib.track.__scAtcWrapped) return;
      var origTrack = sa.lib.track;
      var wrapped = function (name) {
        try {
          if (String(name) === 'Added Product') {
            window.__SC_TREKKIE_ATC_COUNT = (window.__SC_TREKKIE_ATC_COUNT || 0) + 1;
          }
        } catch (e) {}
        return origTrack.apply(this, arguments);
      };
      wrapped.__scAtcWrapped = true;
      sa.lib.track = wrapped;
    } catch (e) {}
  }, 750);
  setTimeout(function () { clearInterval(trekkieSpyTimer); }, 90000);

  function isExcludedLine(item) {
    if (!item) return true;
    var props = item.properties || {};
    if (props._sc_threshold_gift === 'true') return true;
    if (props._seedcube_upsell === 'free_gift') return true;
    if (props._shipping_protection === 'true') return true;
    var cents = item.final_price != null ? item.final_price : item.price;
    if (!cents || cents <= 0) return true;
    var name = (item.product_title || item.title || '').trim();
    if (name === 'Shipping Protection') return true;
    if ((item.product_type || '').trim() === 'Insurance') return true;
    return false;
  }

  function buildPaidVariantMap(cart) {
    var map = Object.create(null);
    if (!cart || !cart.items) return map;
    cart.items.forEach(function (item) {
      if (isExcludedLine(item)) return;
      var vid = String(item.variant_id);
      if (!map[vid]) {
        map[vid] = { qty: 0, item: item };
      }
      map[vid].qty += item.quantity;
      map[vid].item = item;
    });
    return map;
  }

  function cartItemsList(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.map(function (item) {
      return item.title || item.product_title || String(item.product_id || item.variant_id);
    });
  }

  function productUrl(item) {
    var path = item.url || '';
    if (!path) return STORE_ORIGIN;
    if (path.indexOf('http') === 0) {
      try {
        path = new URL(path).pathname;
      } catch (e) {
        path = '';
      }
    }
    if (path.charAt(0) !== '/') path = '/' + path;
    return STORE_ORIGIN + path;
  }

  function imageUrl(item) {
    var img = (item && item.image) || (item && item.featured_image && item.featured_image.url) || '';
    if (!img) return '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    return img;
  }

  function trackPaidLine(item, cart) {
    if (!window._learnq) return;
    var cents = item.final_price != null ? item.final_price : item.price;
    var dollars = cents / 100;
    var name = item.product_title || item.title || '';
    window._learnq.push(['track', 'Added to Cart', {
      '$value': dollars,
      'Product Name': name,
      'Price': dollars,
      'Product Type': item.product_type || '',
      'ProductURL': productUrl(item),
      'ImageURL': imageUrl(item),
      'items': cartItemsList(cart),
      'TrekkieSawAdd': (window.__SC_TREKKIE_ATC_COUNT || 0) > 0,
      'TrekkieATCCount': window.__SC_TREKKIE_ATC_COUNT || 0,
      'PagePath': window.location.pathname
    }]);
  }

  function findPaidIncreases(beforeMap, afterMap) {
    var lines = [];
    Object.keys(afterMap).forEach(function (vid) {
      var was = beforeMap[vid] ? beforeMap[vid].qty : 0;
      var now = afterMap[vid].qty;
      if (now > was) lines.push(afterMap[vid].item);
    });
    return lines;
  }

  function resolveCart(hint) {
    if (hint && window.SC_isValidCart && window.SC_isValidCart(hint)) {
      return Promise.resolve(hint);
    }
    if (window.SC_getSharedCart) {
      return window.SC_getSharedCart({ forceFresh: true });
    }
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      return res.json();
    });
  }

  function initSnapshot() {
    resolveCart(null).then(function (cart) {
      if (cart && cart.items) paidSnapshot = buildPaidVariantMap(cart);
    }).catch(function () {});
  }

  function flushDiff() {
    var hint = pendingCartHint;
    pendingCartHint = null;

    resolveCart(hint).then(function (cart) {
      if (!cart || !cart.items) return;

      var afterMap = buildPaidVariantMap(cart);
      var increases = findPaidIncreases(paidSnapshot, afterMap);

      if (increases.length && window._learnq) {
        increases.forEach(function (line) {
          trackPaidLine(line, cart);
        });
      }

      paidSnapshot = afterMap;
    }).catch(function () {});
  }

  function scheduleDiff(evt) {
    if (evt && evt.detail && evt.detail.cart) {
      pendingCartHint = evt.detail.cart;
    }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(flushDiff, DEBOUNCE_MS);
  }

  document.addEventListener('cart:updated', scheduleDiff);
  document.addEventListener('cart:build', scheduleDiff);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSnapshot);
  } else {
    initSnapshot();
  }
})();
